import React, { useEffect, useState } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import { format, parseISO } from 'date-fns';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination, TextField } from '@mui/material';
import { MdDelete } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import Modal from 'react-bootstrap/Modal';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Player, Controls } from '@lottiefiles/react-lottie-player';
import { FiAlertTriangle } from "react-icons/fi";


export default function Leads() {
    const lottiee = require('../images/lottiee.json');
    const loading = require('../images/loading.json');

    const [smShow, setSmShow] = useState(false);
    const [show, setShow] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(8);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [show2, setShow2] = useState(false);

    const handleClose2 = () => setShow2(false);
    const handleShow2 = () => setShow2(true);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        const newRowsPerPage = parseInt(event.target.value, 10);
        setRowsPerPage(newRowsPerPage);
        setPage(0);
    };

    const [facility, setFacility] = useState([]);
    const [FacilityName, setFacilityName] = useState('');
    const [FacilityDescription, setFacilityDescription] = useState('');
    const [updateFacility, setupdateFacility] = useState({});
    const [showDescription, setShowDescription] = useState({});
    const [loader, setloader] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");

    const handleShowMore = (index) => {
        setShowDescription({ ...showDescription, [index]: true });
    };

    const handleShowLess = (index) => {
        setShowDescription({ ...showDescription, [index]: false });
    };

    const filteredData = facility.filter((item) => {
        return (
            item.FacilityName.toLowerCase().includes(searchQuery.toLowerCase())
        );
    });

    const facilityData = () => {
     setloader(true)
        const requestOptions = {
            method: "GET",
            redirect: "follow"
        };

        fetch("https://api.padampura.com/FacilitiesList", requestOptions)
         .then((response) => response.json())
            .then((result) => {
                if (result.status === true) {
                    // console.log(result)
                    setFacility(result.data)
                    setloader(false)
                }
            })
            .catch((error) => console.error(error))
            .finally(() => setloader(false))
    }

    const insertFacility = () => {
        if(!FacilityName){
            alert("Please enter Facility Name");
            return; // Stop further execution
        }
     const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
            "FacilityName": FacilityName,
            "FacilityDescription": FacilityDescription
        });

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow"
        };

        fetch("https://api.padampura.com/Facilities_Insert", requestOptions)
          .then((response) => response.json())
            .then((result) => {
                if(result.status === true){
                    // console.log(result)
                    facilityData();
                }
            })
            .catch((error) => console.error(error));
    }

    const handleChangeUpdtFacility = (e) => {
        const { name, value, type, checked } = e.target;
        setupdateFacility({
            ...updateFacility,
            [name]: type === "checkbox" ? checked : value,
        });
    };

    const updateFaci = () => {
      const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
            ...updateFacility
        });

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow"
        };

        fetch(`https://api.padampura.com/Facilities_Update?MainID=${updateFacility.Faci_ID}`, requestOptions)
          .then((response) => response.json())
            .then((result) => {
                if (result.status === true) {
                    // console.log(result)
                    facilityData()
                }
            })
            .catch((error) => console.error(error));
    }

    const deleteFacility =()=>{
        const requestOptions = {
            method: "DELETE",
            redirect: "follow"
          };
          
          fetch(`https://api.padampura.com/Facilities_Delete?MainID=${updateFacility.Faci_ID}`, requestOptions)
           .then((response) => response.json())
            .then((result) => {
                if(result.status === true){
                    // console.log(result)
                    alert('Delete Successfully')
                    facilityData()
                }else{
                    alert('Something went wrong')
                }
            })
            .catch((error) => console.error(error));
    }

    useEffect(() => {
        facilityData();
    }, [])

    const handleClear = () => {
        setFacilityName('');
        setFacilityDescription('');
    }

    const sanitizeHtml = (html) => {
        if (html) {
            return html.replace(/<\/?p>/g, '');
        } else {
            return '';
        }
    };

    return (
        <>
            <div className='container-fluid p-0'>
                <div className='row g-0'>
                    <div className='col-2 side'>
                        <Sidebar />
                    </div>
                    <div className='col-10 side2'>
                        <Header />
                        <div className='scroll-box'>
                            <div className="container-fluid">
                                <div className='row d-flex justify-content-between mt-2'>
                                    <div className='col-4' style={{ fontFamily: "Poppins", fontWeight: 600, fontSize: "1.2em", }} >Facilities</div>
                                    <div className='col-4'>
                                        <TextField
                                            label="Search by facility name"
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            sx={{ mb: 0 }}
                                        />
                                    </div>
                                    <div onClick={handleShow} className='col-2 d-flex justify-content-center align-items-center p-1 rounded-1' style={{ backgroundColor: "#2C3E50", fontFamily: "Poppins", fontWeight: 400, color: "#fff", cursor: "pointer" }}>+ Add</div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-12 m-auto">
                                        <div className='card-list-box-sr card p-2 border-0'>
                                            <div className="table-responsive">
                                                <Paper sx={{ width: '100%' }}>
                                                    <TableContainer sx={{ mt: -1 }}>
                                                        <Table stickyHeader aria-label="sticky table" size="small">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell sx={{ fontWeight: "600", minWidth: 50, fontFamily: "Poppins" }}>Facility Name</TableCell>
                                                                    <TableCell sx={{ fontWeight: "600", minWidth: 50, fontFamily: "Poppins" }}>Facility Description</TableCell>
                                                                    <TableCell sx={{ fontWeight: "600", minWidth: 50, fontFamily: "Poppins" }}>Action</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {loader ? (
                                                                    <TableRow>
                                                                        <TableCell colSpan={3} align="center">
                                                                            <div style={{ fontFamily:"Poppins", fontSize:16 }} >Loading...</div>
                                                                            <Player
                                                                                autoplay
                                                                                loop
                                                                                src={loading}
                                                                                style={{ height: '200px', width: '200px' }}
                                                                            >
                                                                            <Controls visible={false} buttons={['play', 'repeat', ]} />
                                                                         </Player>
                                                                        </TableCell>
                                                                    </TableRow>
                                                                ) : filteredData.length === 0 ? (
                                                                    <TableRow>
                                                                        <TableCell colSpan={3} align="center">
                                                                         <Player
                                                                                autoplay
                                                                                loop
                                                                                src={lottiee}
                                                                                style={{ height: '100px', width: '100px' }}
                                                                            >
                                                                            <Controls visible={false} buttons={['play', 'repeat', ]} />
                                                                         <div style={{ fontFamily:"Poppins", fontSize:16, color:'red' }} >Data Not Present...</div>
                                                                         </Player>
                                                                        </TableCell>
                                                                    </TableRow>
                                                                ) : (
                                                                    filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((item, index) => (
                                                                        <TableRow key={index}>
                                                                            <TableCell sx={{ fontWeight: "500", minWidth: 50, fontFamily: "Poppins", fontSize: "12px" }}>
                                                                                <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(item.FacilityName) }} />
                                                                            </TableCell>
                                                                            <TableCell sx={{ fontWeight: "500", minWidth: 50, fontFamily: "Poppins", fontSize: "12px" }}>
                                                                                <div>
                                                                                    {showDescription[index] ? (
                                                                                        <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(item.FacilityDescription) }} />
                                                                                    ) : (
                                                                                        <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(item.FacilityDescription.slice(0, 100)) }} />
                                                                                    )}
                                                                                    {item.FacilityDescription.length > 80 && !showDescription[index] && (
                                                                                        <button className='border-0' onClick={() => handleShowMore(index)} style={{ color: 'blue' }}>...Read More</button>
                                                                                    )}
                                                                                    {item.FacilityDescription.length > 80 && showDescription[index] && (
                                                                                        <button className='border-0' onClick={() => handleShowLess(index)} style={{ color: 'blue' }}>Read Less...</button>
                                                                                    )}
                                                                                </div>
                                                                            </TableCell>
                                                                            <TableCell sx={{ fontWeight: "500", minWidth: 50, fontFamily: "Poppins", }}>
                                                                                <div className='d-flex justify-content-between'>
                                                                                    <FaEdit onClick={() => { handleShow2(); setupdateFacility({ ...item }) }} style={{ cursor: "pointer", color: "#566573" }} />
                                                                                    <MdDelete onClick={()=> {setSmShow(true); setupdateFacility({ ...item })}} style={{ cursor: "pointer", color: "#E74C3C" }} />
                                                                                </div>
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    ))
                                                                )}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                    <TablePagination
                                                        rowsPerPageOptions={[8, 10, 20]}
                                                        component="div"
                                                        count={facility.length}
                                                        rowsPerPage={rowsPerPage}
                                                        page={page}
                                                        onPageChange={handleChangePage}
                                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                                    />
                                                </Paper>
                                                <Modal show={show} onHide={handleClose} size="lg" aria-labelledby="example-modal-sizes-title-lg">
                                                    <Modal.Header closeButton>
                                                        <Modal.Title>Add Facility</Modal.Title>
                                                    </Modal.Header>
                                                    <Modal.Body>
                                                        <div className='container-fluid'>
                                                            <div className='row'>
                                                                <div className='col-2 ms-auto'>
                                                                    <div onClick={() => { insertFacility(); handleClose(); handleClear() }} className='d-flex justify-content-center align-items-center p-1 rounded-1' style={{ width: '100%', backgroundColor: "#2C3E50", fontFamily: "Poppins", fontWeight: 400, color: "#fff", cursor: "pointer" }}>Save</div>
                                                                </div>
                                                            </div>
                                                            <div className='row'>
                                                                <div className='col-lg-12 col-md-12 col-sm-12'>
                                                                    <div className='' style={{ fontFamily: 'Poppins', fontSize: "13px", color: '#1f5156', fontWeight: 600 }}>Facility Name</div>
                                                                    {/* <input className='sercc-inpt p-1' value={FacilityName} onChange={(e)=> setFacilityName(e.target.value)} placeholder="Facility Name" autoFocus required style={{width:"100%"}} /> */}
                                                                    <CKEditor
                                                                        editor={ClassicEditor}
                                                                        data={FacilityName || ''}
                                                                        onChange={(event, editor) => {
                                                                            const data = editor.getData();
                                                                            setFacilityName(data);
                                                                        }}
                                                                        config={{
                                                                            enterMode: 'paragraph',
                                                                            shiftEnterMode: 'br',
                                                                            toolbar: {
                                                                                items: ['heading', '|', 'bold', 'italic', 'alignment', '|', 'undo', 'redo']
                                                                            },
                                                                            heading: {
                                                                                options: [
                                                                                    { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
                                                                                    { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
                                                                                    { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
                                                                                    { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
                                                                                    { model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4' },
                                                                                    { model: 'heading5', view: 'h5', title: 'Heading 5', class: 'ck-heading_heading5' },
                                                                                    { model: 'heading6', view: 'h6', title: 'Heading 6', class: 'ck-heading_heading6' }
                                                                                ]
                                                                            }
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className='' style={{ width: "100%", height: "50vh", overflow: "scroll" }}>
                                                                <div className='' style={{ fontFamily: 'Poppins', fontSize: "13px", color: '#1f5156', fontWeight: 600 }}>Facility Description</div>
                                                                <div className='row'>
                                                                    <div className='col-lg-12 col-md-12 col-sm-12'>
                                                                        {/* <textarea className='sercc-inpt p-1' value={FacilityDescription} onChange={(e)=> setFacilityDescription(e.target.value)} placeholder="Facility Description" autoFocus required style={{width:"100%"}} /> */}
                                                                        <CKEditor
                                                                            editor={ClassicEditor}
                                                                            data={FacilityDescription || ''}
                                                                            onChange={(event, editor) => {
                                                                                const data = editor.getData();
                                                                                setFacilityDescription(data);
                                                                            }}
                                                                            config={{
                                                                                enterMode: 'paragraph',
                                                                                shiftEnterMode: 'br',
                                                                                toolbar: {
                                                                                    items: ['heading', '|', 'bold', 'italic', 'alignment', '|', 'undo', 'redo']
                                                                                },
                                                                                heading: {
                                                                                    options: [
                                                                                        { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
                                                                                        { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
                                                                                        { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
                                                                                        { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
                                                                                        { model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4' },
                                                                                        { model: 'heading5', view: 'h5', title: 'Heading 5', class: 'ck-heading_heading5' },
                                                                                        { model: 'heading6', view: 'h6', title: 'Heading 6', class: 'ck-heading_heading6' }
                                                                                    ]
                                                                                }
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Modal.Body>
                                                </Modal>
                                                <Modal show={show2} onHide={handleClose2} size="lg" aria-labelledby="example-modal-sizes-title-lg">
                                                    <Modal.Header closeButton>
                                                        <Modal.Title>Edit Facility</Modal.Title>
                                                    </Modal.Header>
                                                    <Modal.Body>
                                                        <div className='container-fluid'>
                                                            <div className='row'>
                                                                <div className='col-2 ms-auto'>
                                                                    <div onClick={() => { updateFaci(); handleClose2(); }} className='d-flex justify-content-center align-items-center p-1 rounded-1' style={{ width: '100%', backgroundColor: "#2C3E50", fontFamily: "Poppins", fontWeight: 400, color: "#fff", cursor: "pointer" }}>Update</div>
                                                                </div>
                                                            </div>
                                                            <div className='row'>
                                                                <div className='col-lg-12 col-md-12 col-sm-12'>
                                                                    <div className='' style={{ fontFamily: 'Poppins', fontSize: "13px", color: '#1f5156', fontWeight: 600 }}>Facility Name</div>
                                                                    {/* <input className='sercc-inpt p-1' name='FacilityName' value={updateFacility.FacilityName} onChange={handleChangeUpdtFacility} placeholder="Facility Name" autoFocus required style={{width:"100%"}} /> */}
                                                                    <CKEditor
                                                                        editor={ClassicEditor}
                                                                        data={updateFacility.FacilityName || ''}
                                                                        onChange={(event, editor) => {
                                                                            const data = editor.getData();
                                                                            setupdateFacility({
                                                                                ...updateFacility,
                                                                                FacilityName: data
                                                                            });
                                                                        }}
                                                                        config={{
                                                                            enterMode: 'paragraph',
                                                                            shiftEnterMode: 'br',
                                                                            toolbar: {
                                                                                items: ['heading', '|', 'bold', 'italic', 'alignment', '|', 'undo', 'redo']
                                                                            },
                                                                            heading: {
                                                                                options: [
                                                                                    { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
                                                                                    { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
                                                                                    { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
                                                                                    { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
                                                                                    { model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4' },
                                                                                    { model: 'heading5', view: 'h5', title: 'Heading 5', class: 'ck-heading_heading5' },
                                                                                    { model: 'heading6', view: 'h6', title: 'Heading 6', class: 'ck-heading_heading6' }
                                                                                ]
                                                                            }
                                                                        }}
                                                                    />
                                                                </div>
                                                                {/* <div className='col-lg-6 col-md-6 col-sm-12'>
                                                                <div className='' style={{ fontFamily:'Poppins', fontSize:"13px", color:'#1f5156', fontWeight:600 }}>Facility Description</div>
                                                                <textarea className='sercc-inpt p-1' name='FacilityDescription' value={updateFacility.FacilityDescription} onChange={handleChangeUpdtFacility} placeholder="Facility Description" autoFocus required style={{width:"100%"}} />
                                                            </div> */}
                                                            </div>
                                                            <div className='' style={{ fontFamily: 'Poppins', fontSize: "13px", color: '#1f5156', fontWeight: 600 }}>Facility Description</div>
                                                            <div className='' style={{ width: "100%", height: "50vh", overflow: "scroll" }} >
                                                                <div className='row'>
                                                                    <div className='col-lg-12 col-md-12 col-sm-12'>
                                                                        {/* <textarea className='sercc-inpt p-1' name='FacilityDescription' value={updateFacility.FacilityDescription} onChange={handleChangeUpdtFacility} placeholder="Facility Description" autoFocus required style={{width:"100%"}} /> */}
                                                                        <CKEditor
                                                                            editor={ClassicEditor}
                                                                            data={updateFacility.FacilityDescription || ''}
                                                                            onChange={(event, editor) => {
                                                                                const data = editor.getData();
                                                                                setupdateFacility({
                                                                                    ...updateFacility,
                                                                                    FacilityDescription: data
                                                                                });
                                                                            }}
                                                                            config={{
                                                                                enterMode: 'paragraph',
                                                                                shiftEnterMode: 'br',
                                                                                toolbar: {
                                                                                    items: ['heading', '|', 'bold', 'italic', 'alignment', '|', 'undo', 'redo']
                                                                                },
                                                                                heading: {
                                                                                    options: [
                                                                                        { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
                                                                                        { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
                                                                                        { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
                                                                                        { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
                                                                                        { model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4' },
                                                                                        { model: 'heading5', view: 'h5', title: 'Heading 5', class: 'ck-heading_heading5' },
                                                                                        { model: 'heading6', view: 'h6', title: 'Heading 6', class: 'ck-heading_heading6' }
                                                                                    ]
                                                                                }
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Modal.Body>
                                                </Modal>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal
                size="sm"
                show={smShow}
                onHide={() => setSmShow(false)}
                aria-labelledby="example-modal-sizes-title-sm"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="example-modal-sizes-title-sm">
                        <FiAlertTriangle style={{ color: "orangered" }} />
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="text-center align-items-center" style={{ fontFamily: 'Poppins', fontSize: "16px", color: '#1f5156', fontWeight: 500 }}>Are you sure want to Delete ??</div>
                    <div className='d-flex justify-content-between mt-3'>
                        <div onClick={()=> {setSmShow(false);deleteFacility()}} className='d-flex justify-content-center align-items-center p-1 rounded-1 me-2' style={{ width: '100%', backgroundColor: "#239B56", fontFamily: "Poppins", fontWeight: 400, color: "#fff", cursor: "pointer" }}>Yes</div>
                        <div onClick={()=> setSmShow(false)} className='d-flex justify-content-center align-items-center p-1 rounded-1' style={{ width: '100%', backgroundColor: "#E74C3C", fontFamily: "Poppins", fontWeight: 400, color: "#fff", cursor: "pointer" }}>No</div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}
